import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import maryleboneTownHall from '../assets/images/marylebone-town-hall.jpg';
import williamPub from '../assets/images/william-pub.jpg';
import underground from '../assets/images/underground.svg';

const WeddingInfo = () => {
  const { t } = useTranslation();

  const undergroundIcon = (
    <img src={underground} alt="Underground" className="event-transport-icon" />
  );

  return (
    <div className="wedding-info">
      <h2>{t('weddingDetails')}</h2>

      <div className="event-card ceremony-card">
        <div className="event-image-container">
          <img src={maryleboneTownHall} alt="Old Marylebone Town Hall" className="event-image" />
        </div>
        <h3>{t('ceremony')}</h3>
        <p className="event-date">{t('ceremonyDate')}</p>
        <p className="event-time">{t('ceremonyTime')}</p>
        <p className="event-location">{t('ceremonyLocation')}</p>
        <p className="event-transport">
          {undergroundIcon}
          {t('ceremonyTransport')}
        </p>
        <p className="event-address">{t('ceremonyAddress')}</p>
        <p className="event-description">
          <Trans i18nKey="ceremonyDescription" components={{ 1: <br /> }} />
        </p>
      </div>

      <div className="event-card reception-card">
        <div className="event-image-container">
          <img src={williamPub} alt="The William Pub" className="event-image" />
        </div>
        <h3>{t('reception')}</h3>
        <p className="event-date">{t('receptionDate')}</p>
        <p className="event-time">{t('receptionTime')}</p>
        <p className="event-location">{t('receptionLocation')}</p>
        <p className="event-transport">
          {undergroundIcon}
          {t('receptionTransport')}
        </p>
        <p className="event-address">{t('receptionAddress')}</p>
        <p className="event-description">
          <Trans i18nKey="receptionDescription" components={{ 1: <br /> }} />
        </p>
      </div>
    </div>
  );
};

export default WeddingInfo;
